module.exports = __webpack_public_path__ + "static/media/bannerPrincipal.f52095e5.jpg";